/**
 * 桌面端导航二级菜单：悬停即展开（Dawn 原生 details 只能点击）
 * - 仅 min-width:990px 且支持 hover 的指针设备生效，移动端 drawer 完全不受影响
 * - 点击/键盘 Tab 仍然可用；悬停展开后首次点击不会误关闭
 * - 移开鼠标有 160ms 缓冲，避免鼠标斜向下移时菜单闪关
 */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 160;

  function initMenus() {
    var wrappers = document.querySelectorAll('.header__inline-menu header-menu');
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      var details = wrapper.querySelector('details');
      if (!details || details.dataset.hoverReady === 'true') return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      details.dataset.hoverReady = 'true';

      var closeTimer = null;
      var openedByHover = false;

      function clearTimer() {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function openMenu() {
        clearTimer();
        if (details.open) return;
        openedByHover = true;
        details.setAttribute('open', '');
      }

      function queueClose() {
        clearTimer();
        closeTimer = window.setTimeout(function () {
          details.removeAttribute('open');
          openedByHover = false;
        }, CLOSE_DELAY);
      }

      wrapper.addEventListener('mouseenter', function () {
        if (mq.matches) openMenu();
      });

      wrapper.addEventListener('mouseleave', function () {
        if (mq.matches) queueClose();
      });

      /* 键盘 Tab 到触发词时同样展开，保持可访问性 */
      summary.addEventListener('focus', function () {
        if (mq.matches) openMenu();
      });

      details.addEventListener('toggle', function () {
        if (!details.open) {
          clearTimer();
          openedByHover = false;
        }
      });

      /* 悬停已展开时，第一次点击不要再把它关掉 */
      summary.addEventListener('click', function (event) {
        if (!mq.matches || !details.open || !openedByHover) return;
        event.preventDefault();
        openedByHover = false;
      });

      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          summary.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenus);
  } else {
    initMenus();
  }

  /* Shopify 主题编辑器里切换 section 后会重新渲染，重新绑定一次 */
  document.addEventListener('shopify:section:load', initMenus);
})();
